import React from "react";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
function Loading(props) {
  return /*#__PURE__*/React.createElement(Stack, {
    sx: {
      width: "100%",
      color: "grey.500"
    },
    spacing: 2,
    className: props.className
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    color: "primary"
  }), props.message && /*#__PURE__*/React.createElement("h5", {
    style: {
      color: props.dataSpinnerColor
    }
  }, props.message));
}
export default Loading;
Loading.propTypes = {
  size: PropTypes.number,
  color: PropTypes.number,
  className: PropTypes.string,
  message: PropTypes.string
};